'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var busca = exports.busca = 'https://www.olx.com.br/brasil';
var meusAnuncios = exports.meusAnuncios = 'https://conta.olx.com.br/anuncios';
var chat = exports.chat = 'https://conta.olx.com.br/chats';
var central = exports.central = 'https://conta.olx.com.br/notificacoes';
var inserirAnuncio = exports.inserirAnuncio = 'https://www2.olx.com.br/desapega';
var sair = exports.sair = 'https://www3.olx.com.br/account/do_logout';